module.exports = __webpack_public_path__ + "static/media/dashboardIcon.1c2cd989.svg";